import { axiosApiInstance } from "@/lib/axios";
import { API_PORTAL_URL } from "@/lib/config";
import { IPackageDetail } from "@/types/package.types";
/**
 * Service to fetch a package's details by its URL slug.
 * 1. Primary: POST to /Package/FindByURLPackage with body { URL: slug }
 * 2. Fallback: Offline recovery mock data
 */
export async function fetchPackageBySlug(
  slug: string,
): Promise<IPackageDetail> {
  const cleanSlug = slug.trim().toLowerCase();

  try {
    const response = await axiosApiInstance.post(
      `${API_PORTAL_URL}/Package/FindByURLPackage`,
      {
        URL: cleanSlug,
      },
    );

    if (response.data && response.data.Data) {
      const data = response.data.Data;
      if (data && data.Title) {
        return ensurePackageFieldSafety(data, cleanSlug);
      }
    }
  } catch (error) {
    console.warn("Primary POST fetchPackageBySlug failed:", error);
    throw error;
  }

  throw new Error("Package not found");
}

function ensurePackageFieldSafety(
  pkg: IPackageDetail,
  slug: string,
): IPackageDetail {
  const matchedURL = pkg.URL || slug;

  return {
    ...pkg,
    URL: matchedURL,
    PricePer: pkg.PricePer || "Per Person",
    CancellationPolicy: pkg.CancellationPolicy || "",
    RefundPolicy: pkg.RefundPolicy || "",
    Inclusion: pkg.Inclusion || "",
    Exclusion: pkg.Exclusion || "",
    Instruction: pkg.Instruction || "",
    MetaTitle: pkg.MetaTitle || `${pkg.Title} | Rann Utsav Packages`,
    MetaDescription: pkg.MetaDescription || "",
    MetaKeywords: pkg.MetaKeywords || "",
    PackageWiseResortItinerary: pkg.PackageWiseResortItinerary || [],
    GalleryImages: pkg.GalleryImages || [],
    OtherPackageList: (pkg.OtherPackageList || []).map((item) => ({
      ...item,
      PricePer: item.PricePer || "Per Person",
    })),
    RoomCategoryList: pkg.RoomCategoryList || [],
  };
}
